module.exports = __webpack_public_path__ + "static/img/img-nofound.1702533199132.png";